import { Navigate } from "react-router-dom";
import { MarketingLayout } from "@/components/marketing/MarketingLayout";
import { formatLegalHtml } from "@/lib/legalDocuments";
import * as terms from "@/content/legal/terms";
import * as privacy from "@/content/legal/privacy";
import * as cookies from "@/content/legal/cookies";
import * as refund from "@/content/legal/refund";
import * as impressum from "@/content/legal/impressum";
import * as dpa from "@/content/legal/dpa";

const DOCS = {
  terms: { ...terms, path: "/terms", testId: "public-terms-page" },
  privacy: { ...privacy, path: "/privacy", testId: "public-privacy-page" },
  cookies: { ...cookies, path: "/cookies", testId: "public-cookies-page" },
  refund: { ...refund, path: "/refund", testId: "public-refund-page" },
  impressum: { ...impressum, path: "/impressum", testId: "public-impressum-page" },
  dpa: { ...dpa, path: "/dpa", testId: "public-dpa-page" },
};

export function MarketingLegalPage({ docKey }) {
  const doc = DOCS[docKey];
  if (!doc) return <Navigate to="/" replace />;

  const html = formatLegalHtml(doc.BODY, { title: doc.TITLE });
  const showLastUpdated = docKey === "privacy" || docKey === "cookies" || docKey === "dpa" || docKey === "impressum";

  return (
    <MarketingLayout activePath={doc.path}>
      <section className="legal-doc" data-testid={doc.testId}>
        <div className="wrap">
          <article className="legal-doc-card" data-testid={`${doc.testId}-content`}>
            <p className="legal-eyebrow" data-testid={`${doc.testId}-eyebrow`}>Legal</p>
            <div className="legal-doc-header">
              <h1 data-testid={`${doc.testId}-title`}>{doc.TITLE}</h1>
              <div className="legal-meta" data-testid={`${doc.testId}-meta`}>
                <div className="legal-meta-row">
                  <dt>Effective</dt>
                  <dd>{doc.EFFECTIVE_DATE}</dd>
                </div>
                {showLastUpdated ? (
                  <div className="legal-meta-row">
                    <dt>Last updated</dt>
                    <dd>{doc.EFFECTIVE_DATE}</dd>
                  </div>
                ) : null}
              </div>
            </div>
            <div
              className="prose-legal"
              data-testid={`${doc.testId}-body`}
              dangerouslySetInnerHTML={{ __html: html }}
            />
          </article>
        </div>
      </section>
    </MarketingLayout>
  );
}
